import React, { useState } from 'react';
import { Collapse } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import WithError from '../../../../../components/with-error/WithError';
import { Input } from '../../../../../components/common-inputs';

import scss from './AdditionalFields.module.scss';

const AdditionalFields = ({ disableTextFields, isOpen, onEnter, isTwoDots }) => {
  const { t } = useTranslation('scout');

  return (
    <div className={scss.wrapper}>
      <Collapse in={isOpen} fullWidth>
        <div className={scss.formWrapper}>
          <Field name='focusOn'>
            {({ meta, input }) => (
              <WithLabel variant={LABEL_STYLES.ROW} label={t('topicIdeas')} isBold isTwoDots={isTwoDots}>
                <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                  <Input
                    size='sm'
                    name={input.name}
                    value={input.value}
                    onChange={input.onChange}
                    onFocus={input.onFocus}
                    onBlur={input.onBlur}
                    disabled={disableTextFields}
                    onEnter={onEnter}
                  />
                </WithError>
              </WithLabel>
            )}
          </Field>

          <Field name='byPass'>
            {({ meta, input }) => (
              <WithLabel variant={LABEL_STYLES.ROW} label={t('bypass')} isBold isTwoDots={isTwoDots}>
                <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                  <Input
                    size='sm'
                    name={input.name}
                    value={input.value}
                    onChange={input.onChange}
                    onFocus={input.onFocus}
                    onBlur={input.onBlur}
                    disabled={disableTextFields}
                    onEnter={onEnter}
                  />
                </WithError>
              </WithLabel>
            )}
          </Field>
        </div>
      </Collapse>
    </div>
  );
};

export default AdditionalFields;
